import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Ice_Storm/FeatureServer/1&source=sd)
 *  */
const STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.27,
  colors.amber[300],
  0.66,
  colors.orange[500],
  1.1,
  colors.red[500],
  1.78,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Ice_Storm/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 1.78 – 3.17", 11],
    ["> 1.1 – 1.78", 9],
    ["> 0.66 – 1.1", 7],
    ["> 0.27 – 0.66", 5],
    ["0 – 0.27", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: STOPS[row[1] as number],
  }));
};

export const iceStorm = {
  stops: STOPS,
  props: getLegendRows(),
};
